import LocalStorageKey from "@enums/LocalStorageKey";
import LocalStorageService from "@services/LocalStorageService";

/** Resolves the persist key at read/write time so company name is available after profile loads. */
export function getAppStorePersistKey(name: string): string {
  const workspace = LocalStorageService.getItem<string>(LocalStorageKey.WORKSPACE) ?? '';
  return `${LocalStorageKey.APP_STORAGE_PREFIX}_${workspace}_${name}`;
}
